module.exports = __webpack_public_path__ + "img/img6.624e00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img6.png
// module id = 215
// module chunks = 0